import { render, staticRenderFns } from "./BFormActions.vue?vue&type=template&id=4bde555b"
import script from "./BFormActions.vue?vue&type=script&lang=js"
export * from "./BFormActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports